import { Close, History } from '@mui/icons-material';
import { Button, Chip, Stack, Typography } from '@mui/material';

type Props = {
  label: React.ReactNode;
  status: string;
  color: 'primary' | 'error';
  isHighlighted?: boolean;
  onDelete?: () => void;
  onUndo?: () => void;
};

export const StagedChip = ({
  label,
  status,
  color,
  isHighlighted,
  onDelete,
  onUndo
}: Props) => (
  <Chip
    color={color}
    variant="outlined"
    onDelete={onDelete}
    deleteIcon={<Close />}
    label={
      <Stack
        component="span"
        direction="row"
        alignItems="center"
        gap={1}
        sx={{ color: 'text.primary' }}
      >
        {label}
        <Typography
          component="span"
          variant="caption"
          fontWeight={700}
          color={`${color}.main`}
        >
          {status}
        </Typography>
        {onUndo && (
          <Button
            size="small"
            startIcon={<History />}
            onClick={onUndo}
            sx={{
              minWidth: 0,
              p: 0,
              lineHeight: 1,
              textTransform: 'none',
              fontWeight: 700
            }}
          >
            Undo
          </Button>
        )}
      </Stack>
    }
    sx={{
      borderRadius: '16px',
      borderStyle: 'dashed',
      '& .MuiChip-deleteIcon': { fontSize: '16px' },
      ...(isHighlighted && {
        borderColor: 'info.main',
        borderWidth: 1.5,
        bgcolor: 'info.light'
      })
    }}
  />
);
